import React from 'react'
import styles from './OurReviews.module.scss';
// import { useSelector } from 'react-redux';
// import { getAllReviews } from '../../../redux/reviewsReducer';
// import Slider from 'react-slick';
// import { getInitials } from '../../../utils/fullNameToInitials';
import { ReactGoogleReviews } from 'react-google-reviews';
import "react-google-reviews/dist/index.css";

const OurReviews = ({ourReviewsRef}) => {
  // const reviews = useSelector(getAllReviews);
  const featurableWidgetId = 'b4005424-9c3c-4803-b6d0-9c3be31c5096';

  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   speed: 3000,
  //   autoplaySpeed: 10000,
  //   cssEase: "linear",
  //   arrows: false,
  //   responsive: [
  //     {
  //       breakpoint: 1400,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //         dots: true
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //         initialSlide: 2
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // };

  return (
    <section id={'reviewsSection'} ref={ourReviewsRef} className={styles.ourReviews}>
      <header>
        <h2>Отзывы о нас</h2>
      </header>
      <ReactGoogleReviews maxItems='3' showDots='none' dateDisplay='absolute' maxCharacters='300' layout="carousel" featurableId={featurableWidgetId} />
    </section>
  )
}

export default OurReviews